export const actions = {
    reset: {
        icon: '⊘',
        text: 'Reset overrides',
        subtitle: 'Clear overrides',
    },
    reload: {
        icon: '⊙',
        text: 'Reload the page',
        subtitle: '⌘ R',
    },
};
